/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateSchoolEducationViewModel } from "../types/UpdateSchoolEducationViewModel.ts";
import { eSchoolEducationLevelSchema } from "./eSchoolEducationLevelSchema.ts";

export const updateSchoolEducationViewModelSchema = z.object({
  school: z
    .string()
    .describe("Nome da instituição de ensino. Obrigatório.")
    .nullish(),
  course: z
    .string()
    .describe("Nome do curso realizado. Obrigatório.")
    .nullish(),
  area: z
    .string()
    .describe("Área de conhecimento do curso. Obrigatório.")
    .nullish(),
  level: z.optional(
    z
      .lazy(() => eSchoolEducationLevelSchema)
      .describe(
        "0 = Uninformed | 1 = FullTop | 2 = Master | 3 = Doctor | 4 = Expert | ",
      ),
  ),
  dateCompletion: z
    .string()
    .datetime()
    .describe("Data de conclusão do curso. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdateSchoolEducationViewModel>;
